import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Badge } from '../ui/badge';
import { Input } from '../ui/input';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table';
import { lettersAPI, LETTER_STATUS, RISK_COLOR } from '../../lib/lettersAPI';

const fmt = (iso) => (iso ? new Date(iso).toLocaleDateString('en-AU') : '—');

export const LetterTable = ({ status }) => {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [f, setF] = useState({ q: '', category: '', date_from: '', date_to: '' });
  const load = useCallback(() => lettersAPI.list({ status, ...f }).then(setRows).catch(() => setRows([])), [status, f]);
  useEffect(() => { load(); }, [load]);
  const cats = [...new Set(rows.map((r) => r.category))];
  return (
    <div className="space-y-3">
      <div className="flex flex-wrap gap-2" data-testid={`letters-filters-${status || 'all'}`}>
        <Input placeholder="Search client, template or reference" className="max-w-xs" value={f.q} onChange={(e) => setF({ ...f, q: e.target.value })} data-testid="letters-search" />
        <select className="h-9 rounded-md border bg-background px-2 text-sm" value={f.category} onChange={(e) => setF({ ...f, category: e.target.value })} data-testid="letters-filter-category">
          <option value="">All categories</option>{cats.map((c) => <option key={c}>{c}</option>)}</select>
        <Input type="date" className="w-40" value={f.date_from} onChange={(e) => setF({ ...f, date_from: e.target.value })} data-testid="letters-filter-from" />
        <Input type="date" className="w-40" value={f.date_to} onChange={(e) => setF({ ...f, date_to: e.target.value })} data-testid="letters-filter-to" />
      </div>
      <div className="overflow-x-auto rounded-md border">
        <Table>
          <TableHeader><TableRow><TableHead>Reference</TableHead><TableHead>Client / entity</TableHead><TableHead>Template</TableHead><TableHead>Risk</TableHead><TableHead>Status</TableHead><TableHead>Updated</TableHead></TableRow></TableHeader>
          <TableBody>
            {rows.length === 0 && <TableRow><TableCell colSpan={6} className="py-8 text-center text-sm text-muted-foreground">No letters</TableCell></TableRow>}
            {rows.map((r) => (
              <TableRow key={r.id} className="cursor-pointer hover:bg-muted/50" onClick={() => navigate(`/letters/${r.id}`)} data-testid={`letter-row-${r.id}`}>
                <TableCell className="font-mono text-xs">{r.reference || 'Draft'}</TableCell>
                <TableCell><div className="font-medium">{r.client_name}</div><div className="text-xs text-muted-foreground">{r.entity?.name}</div></TableCell>
                <TableCell className="text-sm">{r.template_name}<div className="text-xs text-muted-foreground">{r.category} · v{r.template_version}</div></TableCell>
                <TableCell><Badge className={RISK_COLOR[r.risk]}>{r.risk}</Badge></TableCell>
                <TableCell><Badge className={LETTER_STATUS[r.status]?.[1]}>{LETTER_STATUS[r.status]?.[0] || r.status}</Badge></TableCell>
                <TableCell className="text-xs text-muted-foreground">{fmt(r.updated_at)}</TableCell>
              </TableRow>))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
};
